import { isClient } from "~utils/isClient";

// https://bbgithub.dev.bloomberg.com/Consumer-Web/lineup/blob/main/doc/architecture/decisions/0004-nextjs-hydration-patch.md
export const getHydratedInitialPageProps = () => {
    if (!isClient()) {
        return {};
    }

    const initialPageProps = window?.__NEXT_DATA__?.props.pageProps || {};

    // unless server error, don't attempt to re-hydrate from __NEXT_DATA__
    if (!initialPageProps.serverError) {
        return {};
    }

    return initialPageProps;
};
